/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionFlowAccessGuideDTO,
  AppapproDTO,
  GetAccountBalancesParams,
  GetGuarenteedLoansParams,
  GetLoanApprovalGuideParams,
  GetLoanApprovalGuideSimplifiedParams,
  LoanApprovalGuideResponse,
  LoanGuaranteeRequest,
  TransactionDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Resubmit a loan application that was returned for revision
 * @summary Resubmit returned loan
 */
export const resubmitLoan = (
    branch: string,
    custNo: string,
    appapproDTO: AppapproDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO>(
      {url: `/api/loans/resubmit/${branch}/${custNo}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appapproDTO, signal
    },
      options);
    }
  


export const getResubmitLoanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resubmitLoan>>, TError,{branch: string;custNo: string;data: AppapproDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resubmitLoan>>, TError,{branch: string;custNo: string;data: AppapproDTO}, TContext> => {

const mutationKey = ['resubmitLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resubmitLoan>>, {branch: string;custNo: string;data: AppapproDTO}> = (props) => {
          const {branch,custNo,data} = props ?? {};

          return  resubmitLoan(branch,custNo,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResubmitLoanMutationResult = NonNullable<Awaited<ReturnType<typeof resubmitLoan>>>
    export type ResubmitLoanMutationBody = AppapproDTO
    export type ResubmitLoanMutationError = unknown

    /**
 * @summary Resubmit returned loan
 */
export const useResubmitLoan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resubmitLoan>>, TError,{branch: string;custNo: string;data: AppapproDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resubmitLoan>>,
        TError,
        {branch: string;custNo: string;data: AppapproDTO},
        TContext
      > => {

      const mutationOptions = getResubmitLoanMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Process a loan guarantee request
 * @summary Guarantee a loan
 */
export const doGuarantee = (
    branch: string,
    custNo: string,
    loanGuaranteeRequest: LoanGuaranteeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO>(
      {url: `/api/loans/guarantee/${branch}/${custNo}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanGuaranteeRequest, signal
    },
      options);
    }
  


export const getDoGuaranteeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof doGuarantee>>, TError,{branch: string;custNo: string;data: LoanGuaranteeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof doGuarantee>>, TError,{branch: string;custNo: string;data: LoanGuaranteeRequest}, TContext> => {

const mutationKey = ['doGuarantee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof doGuarantee>>, {branch: string;custNo: string;data: LoanGuaranteeRequest}> = (props) => {
          const {branch,custNo,data} = props ?? {};

          return  doGuarantee(branch,custNo,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DoGuaranteeMutationResult = NonNullable<Awaited<ReturnType<typeof doGuarantee>>>
    export type DoGuaranteeMutationBody = LoanGuaranteeRequest
    export type DoGuaranteeMutationError = unknown

    /**
 * @summary Guarantee a loan
 */
export const useDoGuarantee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof doGuarantee>>, TError,{branch: string;custNo: string;data: LoanGuaranteeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof doGuarantee>>,
        TError,
        {branch: string;custNo: string;data: LoanGuaranteeRequest},
        TContext
      > => {

      const mutationOptions = getDoGuaranteeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Create a new loan application or update an existing one
 * @summary Apply for loan
 */
export const applyLoan = (
    branch: string,
    custNo: string,
    appapproDTO: AppapproDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO>(
      {url: `/api/loans/apply/${branch}/${custNo}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appapproDTO, signal
    },
      options);
    }
  


export const getApplyLoanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyLoan>>, TError,{branch: string;custNo: string;data: AppapproDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof applyLoan>>, TError,{branch: string;custNo: string;data: AppapproDTO}, TContext> => {

const mutationKey = ['applyLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyLoan>>, {branch: string;custNo: string;data: AppapproDTO}> = (props) => {
          const {branch,custNo,data} = props ?? {};

          return  applyLoan(branch,custNo,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApplyLoanMutationResult = NonNullable<Awaited<ReturnType<typeof applyLoan>>>
    export type ApplyLoanMutationBody = AppapproDTO
    export type ApplyLoanMutationError = unknown

    /**
 * @summary Apply for loan
 */
export const useApplyLoan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyLoan>>, TError,{branch: string;custNo: string;data: AppapproDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyLoan>>,
        TError,
        {branch: string;custNo: string;data: AppapproDTO},
        TContext
      > => {

      const mutationOptions = getApplyLoanMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAccountBalances = (
    branch: string,
    custNo: string,
    params: GetAccountBalancesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionDTO[]>(
      {url: `/api/loans/${branch}/${custNo}/repayments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAccountBalancesQueryKey = (branch?: string,
    custNo?: string,
    params?: GetAccountBalancesParams,) => {
    return [`/api/loans/${branch}/${custNo}/repayments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getAccountBalances>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetAccountBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountBalancesQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountBalances>>> = ({ signal }) => getAccountBalances(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAccountBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountBalances>>>
export type GetAccountBalancesQueryError = unknown


export function useGetAccountBalances<TData = Awaited<ReturnType<typeof getAccountBalances>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetAccountBalancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountBalances>>,
          TError,
          Awaited<ReturnType<typeof getAccountBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountBalances<TData = Awaited<ReturnType<typeof getAccountBalances>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetAccountBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountBalances>>,
          TError,
          Awaited<ReturnType<typeof getAccountBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountBalances<TData = Awaited<ReturnType<typeof getAccountBalances>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetAccountBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAccountBalances<TData = Awaited<ReturnType<typeof getAccountBalances>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetAccountBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAccountBalancesQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGuarenteedLoans = (
    branch: string,
    custNo: string,
    params: GetGuarenteedLoansParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO[]>(
      {url: `/api/loans/${branch}/${custNo}/guaranteed-loans`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetGuarenteedLoansQueryKey = (branch?: string,
    custNo?: string,
    params?: GetGuarenteedLoansParams,) => {
    return [`/api/loans/${branch}/${custNo}/guaranteed-loans`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGuarenteedLoansQueryOptions = <TData = Awaited<ReturnType<typeof getGuarenteedLoans>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetGuarenteedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuarenteedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuarenteedLoansQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuarenteedLoans>>> = ({ signal }) => getGuarenteedLoans(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuarenteedLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGuarenteedLoansQueryResult = NonNullable<Awaited<ReturnType<typeof getGuarenteedLoans>>>
export type GetGuarenteedLoansQueryError = unknown


export function useGetGuarenteedLoans<TData = Awaited<ReturnType<typeof getGuarenteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetGuarenteedLoansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuarenteedLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuarenteedLoans>>,
          TError,
          Awaited<ReturnType<typeof getGuarenteedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGuarenteedLoans<TData = Awaited<ReturnType<typeof getGuarenteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetGuarenteedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuarenteedLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuarenteedLoans>>,
          TError,
          Awaited<ReturnType<typeof getGuarenteedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGuarenteedLoans<TData = Awaited<ReturnType<typeof getGuarenteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetGuarenteedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuarenteedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGuarenteedLoans<TData = Awaited<ReturnType<typeof getGuarenteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetGuarenteedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuarenteedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGuarenteedLoansQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get the loan repayment transactions for a specific customer
 * @summary Get loan repayments
 */
export const getLoanRepayment = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionDTO[]>(
      {url: `/api/loans/repayment/${branch}/${custNo}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLoanRepaymentQueryKey = (branch?: string,
    custNo?: string,) => {
    return [`/api/loans/repayment/${branch}/${custNo}`] as const;
    }

    
export const getGetLoanRepaymentQueryOptions = <TData = Awaited<ReturnType<typeof getLoanRepayment>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRepayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanRepaymentQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanRepayment>>> = ({ signal }) => getLoanRepayment(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanRepayment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanRepaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanRepayment>>>
export type GetLoanRepaymentQueryError = unknown


export function useGetLoanRepayment<TData = Awaited<ReturnType<typeof getLoanRepayment>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRepayment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanRepayment>>,
          TError,
          Awaited<ReturnType<typeof getLoanRepayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanRepayment<TData = Awaited<ReturnType<typeof getLoanRepayment>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRepayment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanRepayment>>,
          TError,
          Awaited<ReturnType<typeof getLoanRepayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanRepayment<TData = Awaited<ReturnType<typeof getLoanRepayment>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRepayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan repayments
 */

export function useGetLoanRepayment<TData = Awaited<ReturnType<typeof getLoanRepayment>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRepayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanRepaymentQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get loans guaranteed by a specific customer
 * @summary Get guaranteed loans
 */
export const getGuaranteedLoans = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO[]>(
      {url: `/api/loans/guaranteed/${branch}/${custNo}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetGuaranteedLoansQueryKey = (branch?: string,
    custNo?: string,) => {
    return [`/api/loans/guaranteed/${branch}/${custNo}`] as const;
    }

    
export const getGetGuaranteedLoansQueryOptions = <TData = Awaited<ReturnType<typeof getGuaranteedLoans>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuaranteedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuaranteedLoansQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuaranteedLoans>>> = ({ signal }) => getGuaranteedLoans(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuaranteedLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGuaranteedLoansQueryResult = NonNullable<Awaited<ReturnType<typeof getGuaranteedLoans>>>
export type GetGuaranteedLoansQueryError = unknown


export function useGetGuaranteedLoans<TData = Awaited<ReturnType<typeof getGuaranteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuaranteedLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuaranteedLoans>>,
          TError,
          Awaited<ReturnType<typeof getGuaranteedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGuaranteedLoans<TData = Awaited<ReturnType<typeof getGuaranteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuaranteedLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuaranteedLoans>>,
          TError,
          Awaited<ReturnType<typeof getGuaranteedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGuaranteedLoans<TData = Awaited<ReturnType<typeof getGuaranteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuaranteedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get guaranteed loans
 */

export function useGetGuaranteedLoans<TData = Awaited<ReturnType<typeof getGuaranteedLoans>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuaranteedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGuaranteedLoansQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get the approval guide for a specific loan product
 * @summary Get loan approval guide
 */
export const getLoanApprovalGuide = (
    params: GetLoanApprovalGuideParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowAccessGuideDTO[]>(
      {url: `/api/loans/approval-guide`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetLoanApprovalGuideQueryKey = (params?: GetLoanApprovalGuideParams,) => {
    return [`/api/loans/approval-guide`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLoanApprovalGuideQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError = unknown>(params: GetLoanApprovalGuideParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApprovalGuideQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApprovalGuide>>> = ({ signal }) => getLoanApprovalGuide(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanApprovalGuideQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApprovalGuide>>>
export type GetLoanApprovalGuideQueryError = unknown


export function useGetLoanApprovalGuide<TData = Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError = unknown>(
 params: GetLoanApprovalGuideParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApprovalGuide>>,
          TError,
          Awaited<ReturnType<typeof getLoanApprovalGuide>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanApprovalGuide<TData = Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError = unknown>(
 params: GetLoanApprovalGuideParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApprovalGuide>>,
          TError,
          Awaited<ReturnType<typeof getLoanApprovalGuide>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanApprovalGuide<TData = Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError = unknown>(
 params: GetLoanApprovalGuideParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan approval guide
 */

export function useGetLoanApprovalGuide<TData = Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError = unknown>(
 params: GetLoanApprovalGuideParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuide>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanApprovalGuideQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get simplified approval guide with clear indication of dynamic approver requirements
 * @summary Get simplified loan approval guide
 */
export const getLoanApprovalGuideSimplified = (
    params: GetLoanApprovalGuideSimplifiedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanApprovalGuideResponse>(
      {url: `/api/loans/approval-guide-simplified`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetLoanApprovalGuideSimplifiedQueryKey = (params?: GetLoanApprovalGuideSimplifiedParams,) => {
    return [`/api/loans/approval-guide-simplified`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLoanApprovalGuideSimplifiedQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError = unknown>(params: GetLoanApprovalGuideSimplifiedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApprovalGuideSimplifiedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>> = ({ signal }) => getLoanApprovalGuideSimplified(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanApprovalGuideSimplifiedQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>>
export type GetLoanApprovalGuideSimplifiedQueryError = unknown


export function useGetLoanApprovalGuideSimplified<TData = Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError = unknown>(
 params: GetLoanApprovalGuideSimplifiedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>,
          TError,
          Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanApprovalGuideSimplified<TData = Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError = unknown>(
 params: GetLoanApprovalGuideSimplifiedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>,
          TError,
          Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanApprovalGuideSimplified<TData = Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError = unknown>(
 params: GetLoanApprovalGuideSimplifiedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get simplified loan approval guide
 */

export function useGetLoanApprovalGuideSimplified<TData = Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError = unknown>(
 params: GetLoanApprovalGuideSimplifiedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApprovalGuideSimplified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanApprovalGuideSimplifiedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get loan applications for a specific customer
 * @summary Get loan applications
 */
export const getLoanApplications = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO[]>(
      {url: `/api/loans/applications/${branch}/${custNo}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLoanApplicationsQueryKey = (branch?: string,
    custNo?: string,) => {
    return [`/api/loans/applications/${branch}/${custNo}`] as const;
    }

    
export const getGetLoanApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApplicationsQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApplications>>> = ({ signal }) => getLoanApplications(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApplications>>>
export type GetLoanApplicationsQueryError = unknown


export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplications>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplications>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan applications
 */

export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanApplicationsQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



